import React from 'react';
import { FormGroup, FormField } from 'semantic-ui-react';

import { QUESTIONS, TRIAGE_QUESTION_ID } from '../fixtures';

import type { SharedProps } from './shared';

const DELIVERED_WRONG_ADDRESS =
  'Delivered to wrong address (only select this option after confirming address we have on file with member and ensuring it aligns but tracking shows delivered elsewhere)';

/**
 * Member did NOT receive path: 65 → (66a→66b or 66b) → 56b (if NRx error) → 62
 */
export const NotReceivedPathSection: React.FC<SharedProps> = ({ handleQuestion, getAnswer }) => {
  const q19 = getAnswer(TRIAGE_QUESTION_ID.NOT_RECEIVED_REASON);
  const q66a = getAnswer(TRIAGE_QUESTION_ID.INTERNAL_OR_VENDOR_ERROR);
  const q37 = getAnswer(TRIAGE_QUESTION_ID.WILL_REPLACE_ORDER);
  const q35 = getAnswer(TRIAGE_QUESTION_ID.SEVEN_DAY_OVERRIDE);

  const isWrongAddress = q19 === DELIVERED_WRONG_ADDRESS;
  const isNourishedRxError = q66a === 'NourishedRx - internal error';
  const isVendorError = q66a === 'Vendor/Courier - external error';

  const show66a = isWrongAddress;
  const _show66b = isWrongAddress && q66a;
  const show35 = q37 === 'Yes';
  const _canProceedTo62 = isWrongAddress
    ? (isVendorError && q37) || (isNourishedRxError && q35)
    : q19 && !isWrongAddress;

  // Re-read: wrong address → INTERNAL_OR_VENDOR_ERROR (66a) then follow-ups; other reasons → 37/35 path directly.
  // So: wrong address → 66a → 66b; others → 66b directly
  const show66bForOthers = q19 && !isWrongAddress;
  const show66bForWrongAddr = isWrongAddress && q66a;

  return (
    <>
      <FormGroup grouped>
        <label>{QUESTIONS[TRIAGE_QUESTION_ID.NOT_RECEIVED_REASON].questionText}</label>
        {QUESTIONS[TRIAGE_QUESTION_ID.NOT_RECEIVED_REASON].options.map((option) => (
          <FormField
            key={option}
            label={option}
            control="input"
            type="radio"
            name="notReceivedIssue"
            checked={q19 === option}
            onChange={() => handleQuestion(TRIAGE_QUESTION_ID.NOT_RECEIVED_REASON, option)}
          />
        ))}
      </FormGroup>

      {show66a && (
        <FormGroup grouped>
          <label>{QUESTIONS[TRIAGE_QUESTION_ID.INTERNAL_OR_VENDOR_ERROR].questionText}</label>
          {QUESTIONS[TRIAGE_QUESTION_ID.INTERNAL_OR_VENDOR_ERROR].options.map((option) => (
            <FormField
              key={option}
              label={option}
              control="input"
              type="radio"
              name="errorSource"
              checked={q66a === option}
              onChange={() => handleQuestion(TRIAGE_QUESTION_ID.INTERNAL_OR_VENDOR_ERROR, option)}
            />
          ))}
        </FormGroup>
      )}

      {(show66bForWrongAddr || show66bForOthers) && (
        <FormGroup grouped>
          <label>{QUESTIONS[TRIAGE_QUESTION_ID.WILL_REPLACE_ORDER].questionText}</label>
          {QUESTIONS[TRIAGE_QUESTION_ID.WILL_REPLACE_ORDER].options.map((option) => (
            <FormField
              key={option}
              label={option}
              control="input"
              type="radio"
              name="replacingNotReceived"
            checked={q37 === option}
            onChange={() => handleQuestion(TRIAGE_QUESTION_ID.WILL_REPLACE_ORDER, option)}
            />
          ))}
        </FormGroup>
      )}

      {show35 && (
        <FormGroup grouped>
          <label>{QUESTIONS[TRIAGE_QUESTION_ID.SEVEN_DAY_OVERRIDE].questionText}</label>
          {QUESTIONS[TRIAGE_QUESTION_ID.SEVEN_DAY_OVERRIDE].options.map((option) => (
            <FormField
              key={option}
              label={option}
              control="input"
              type="radio"
              name="overrideNotReceived"
            checked={q35 === option}
            onChange={() => handleQuestion(TRIAGE_QUESTION_ID.SEVEN_DAY_OVERRIDE, option)}
            />
          ))}
        </FormGroup>
      )}
    </>
  );
};
